import { useDraggable } from "@dnd-kit/core";
import type { StatusContainerId } from "../dnd";
import { StatusItem, type StatusItemBaseProps } from "./status-item";

type Props = StatusItemBaseProps & { container: StatusContainerId };

export const DraggableStatusItem = ({ container, ...props }: Props) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: props.status.code,
    data: { container },
  });

  return (
    <StatusItem
      ref={setNodeRef}
      isDragging={isDragging}
      {...attributes}
      {...listeners}
      {...props}
    />
  );
};
